import { useMemo } from 'react';
import { Bar } from 'react-chartjs-2';
import { Align } from 'chart.js';
import gettext from '@sdk/lang/gettext';
import palette from '@sdk/theme/colorsLight';

import './chartjsRegister';
import { BarChartContainer } from './barChartComponent.styles';

export type Props = {
  data: Record<string, number>;
  labels: string[];
  chartsScaleFactor: number;
};

const getOtions = (maxYValue: number, chartsScaleFactor: number) => ({
  scales: {
    y: {
      beginAtZero: true,
      max: maxYValue,
      ticks: {
        color: palette.iconGray,
        font: {
          size: 12 * chartsScaleFactor,
        },
      },
      grid: {
        color: palette.separatorOnWhite,
      },
      border: {
        display: false,
      },
    },
    x: {
      grid: {
        display: false,
      },
      ticks: {
        color: palette.primaryText,
        font: {
          size: 12 * chartsScaleFactor,
        },
      },
    },
  },
  maintainAspectRatio: false,
  responsive: true,
  plugins: {
    tooltip: {
      enabled: false,
    },
    legend: {
      display: false,
    },
    title: {
      display: true,
      text: gettext('Break down by rating'),
      align: 'start' as Align,
      color: palette.gray,
      padding: {
        top: 10 * chartsScaleFactor,
        bottom: 15 * chartsScaleFactor,
      },
      font: {
        size: 12 * chartsScaleFactor,
      },
    },
  },
});

export const BarChartComponent = ({ data, labels, chartsScaleFactor }: Props) => {
  const options = useMemo(() => {
    return getOtions(Math.max(5, ...Object.values(data)), chartsScaleFactor);
  }, [data, chartsScaleFactor]);

  const chartData = {
    labels,
    datasets: [
      {
        label: 'Rating',
        backgroundColor: palette.primary,
        hoverBackgroundColor: palette.primary,
        data: labels.map((label) => data[label]),
        barThickness: 50,
      },
    ],
  };

  return (
    <BarChartContainer style={{ height: 200 }}>
      <Bar data={chartData} options={options} />
    </BarChartContainer>
  );
};
